[
  {
    "position": 1,
    "name": "happy-life",
    "icon": "product-family",
    "buyUrl": "call-me-back",
    "learnMoreUrl": "https://www.allianz.sk/sk_SK/sukromne-osoby/zivot/stastny-zivot.html"
  },
  {
    "position": 2,
    "name": "my-home",
    "icon": "product-house",
    "buyUrl": "https://www.allianz.sk/sk_SK/test/Q_B/Q_B_PRIVAT_TEST.html",
    "learnMoreUrl": "https://www.allianz.sk/sk_SK/sukromne-osoby/majetok/moj-domov.html"
  },
  {
    "position": 3,
    "name": "my-car",
    "icon": "product-car-front",
    "buyUrl": "https://www.allianz.sk/sk_SK/test/Q_B/Q_B_MOTOR_TEST.html",
    "learnMoreUrl": "https://www.allianz.sk/sk_SK/sukromne-osoby/vozidla/moje-auto.html"
  },
  {
    "position": 4,
    "name": "travel-insurance",
    "icon": "product-plane",
    "buyUrl": "https://www.allianz.sk/sk_SK/test/cestovne/cestovne-test.html",
    "learnMoreUrl": "https://www.allianz.sk/sk_SK/sukromne-osoby/dalsie-produkty/cestovne-poistenie.html"
  },
  {
    "position": 5,
    "name": "liability-insurance",
    "icon": "product-shield-hand",
    "buyUrl": "https://www.allianz.sk/sk_SK/test/zodpovednost/zodpovednost-test.html",
    "learnMoreUrl": "https://www.allianz.sk/sk_SK/podnikatelia/zamestnanci/zodpovednost-zamestnanca-za-skodu-podnikatelia.html"
  },
  {
    "position": 6,
    "name": "travel-cancelation-insurance",
    "icon": "product-money-banknote",
    "buyUrl": "https://www.allianz.sk/sk_SK/test/storno-zajazdu/storno-zajazdu-test.html",
    "learnMoreUrl": "https://www.allianz.sk/sk/sukromne-osoby/cestovanie/poistenie-storna.html"
  },
  {
    "position": 7,
    "name": "mountain-rescue-insurance",
    "icon": "mountain-rescue",
    "buyUrl": "https://www.allianz.sk/sk_SK/test/horska-sluzba/horska-test.html",
    "learnMoreUrl": "https://www.allianz.sk/sk_SK/sukromne-osoby/dalsie-produkty/poistenie-do-hor.html"
  }
]
